/*!
 *
 *  tab.ts
 *
 *  @template: `
        <div class="tab">
            <div role="tablist" aria-label="タブ">
                <button role="tab" aria-selected="true" aria-controls="panel-1" id="tab-1" tabindex="0">
                    First Tab
                </button>
                <button role="tab" aria-selected="false" aria-controls="panel-2" id="tab-2" tabindex="-1">
                    Second Tab
                </button>
                <button role="tab" aria-selected="false" aria-controls="panel-3" id="tab-3" tabindex="-1">
                    Third Tab
                </button>
            </div>
            <div id="panel-1" role="tabpanel" tabindex="0" aria-labelledby="tab-1" aria-hidden="false">
                <p>Content for the first panel</p>
            </div>
            <div id="panel-2" role="tabpanel" tabindex="0" aria-labelledby="tab-2" aria-hidden="true" hidden>
                <p>Content for the second panel</p>
                <p><a href="#">Link for the second panel</a></p>
            </div>
            <div id="panel-3" role="tabpanel" tabindex="0" aria-labelledby="tab-3" aria-hidden="true" hidden>
                <p>Content for the third panel</p>
                <p><a href="#">Link for the third panel</a></p>
            </div>
        </div>
 *  `
 */
import urlParams from "url-params";
var TabNavigation = /** @class */ (function () {
    function TabNavigation(elem) {
        this.currentTabIndex = 0;
        this.tabList = elem.querySelector('[role="tablist"]');
        this.tabButton = elem.querySelectorAll('[role="tab"]');
        this.tabPanels = elem.querySelectorAll('[role="tabpanel"]');
        var id = urlParams.get('tab');
        var currentPanel = Array.from(this.tabPanels).find(function (panel) { return panel.id === id; });
        if (currentPanel) {
            this.currentTabIndex = Array.from(this.tabPanels).indexOf(currentPanel);
        }
        ;
        this.init();
    }
    TabNavigation.prototype.init = function () {
        var _this = this;
        this.tabButton.forEach(function (tab, index) {
            var isActive = index === _this.currentTabIndex;
            tab.setAttribute('aria-selected', isActive.toString());
            tab.setAttribute('tabindex', isActive ? '0' : '-1');
            tab.addEventListener('click', function (e) {
                e.preventDefault();
                _this.changeTab(tab);
            });
        });
        this.tabList.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                _this.tabButton[_this.currentTabIndex].setAttribute('tabindex', '-1');
                if (e.key === 'ArrowRight') {
                    console.log('?' + 1 % 3);
                    _this.currentTabIndex = (_this.currentTabIndex + 1) % _this.tabButton.length;
                }
                else if (e.key === 'ArrowLeft') {
                    _this.currentTabIndex = (_this.currentTabIndex - 1 + _this.tabButton.length) % _this.tabButton.length;
                }
                ;
                _this.tabButton[_this.currentTabIndex].setAttribute('tabindex', '0');
                _this.tabButton[_this.currentTabIndex].focus();
            }
        });
        this.changeTab(this.tabButton[this.currentTabIndex]);
    };
    TabNavigation.prototype.changeTab = function (button) {
        var panelId = button.getAttribute('aria-controls') || '';
        var panel = document.getElementById(panelId);
        if (!panel)
            return;
        this.tabButton.forEach(function (t) {
            var isActive = t === button;
            t.setAttribute('aria-selected', "".concat(isActive));
            t.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        this.tabPanels.forEach(function (p) {
            var isActive = p === panel;
            p.setAttribute('aria-hidden', "".concat(!isActive));
            // if (isActive) {
            // 	p.removeAttribute('hidden');
            // } else {
            // 	p.setAttribute('hidden', `${!isActive}`);
            // };
        });
        this.currentTabIndex = Array.from(this.tabButton).indexOf(button);
    };
    return TabNavigation;
}());
export default function (elemName) {
    var tabElements = document.querySelectorAll(elemName);
    tabElements.forEach(function (elem) {
        new TabNavigation(elem);
    });
}
